import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgFinanceAndBankingIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.3}
      d="M28.217 10.84v13.124l1.098 1.099zm0 0h.694a.572.572 0 0 0 .572-.573V6.89a.572.572 0 0 0-.402-.547l-12.244-3.8a.565.565 0 0 0-.34 0l-12.245 3.8a.572.572 0 0 0-.402.547v3.377c0 .317.256.572.572.572h.695v13.125l-1.1 1.099a.57.57 0 0 0-.167.404v2.111c0 .317.256.573.572.573h24.49a.572.572 0 0 0 .571-.573v-2.11a.57.57 0 0 0-.167-.405l-1.1-14.223Zm-2.261-1.69h2.383v.545H4.994v-.544h2.534V8.006H4.994v-.695l11.673-3.622L28.339 7.31v.695h-2.533V9.15zM11.45 10.84v12.788H8.794V10.84zm6.756 0v12.788h-3.078V10.84zm6.333 0v12.788h-2.656V10.84zm-3.8 12.788H19.35V10.84h1.389v12.79Zm-6.756 0h-1.389V10.84h1.39v12.79Zm-6.333 0H6.261V10.84H7.65v12.79Zm-2.656 3.378v-1.302l.932-.931h21.481l.932.931v1.302zm22.078-3.378h-1.389V10.84h1.39v12.79Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.3}
      d="M16.667 4.628a2.264 2.264 0 0 0-2.261 2.261 2.264 2.264 0 0 0 2.26 2.262 2.264 2.264 0 0 0 2.262-2.262 2.264 2.264 0 0 0-2.261-2.26Zm0 3.378A1.118 1.118 0 0 1 15.55 6.89a1.117 1.117 0 1 1 1.117 1.117Z"
    />
  </svg>
);
export default SvgFinanceAndBankingIcon;
